import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { useIsFirstRenderRef } from '#/hooks/useIsFirstRenderRef';
import { useI18n } from '#/i18n/hooks/useI18n';
import { authLoginAuthRequiredSearchParam } from '#/modules/auth/routing/auth.routes';
import { tickFlashes, flash } from '#/zustand-stores/flashesStore';
import { useHorizonFlashActions } from '#/zustand-stores/horizonFlashStore';

export function SetFlashesGlobalHandler() {
  const { i18n } = useI18n();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const { isFirstRenderRef } = useIsFirstRenderRef();
  const { clearHorizonFlash } = useHorizonFlashActions();

  useEffect(() => {
    if (isFirstRenderRef.current) return;
    tickFlashes();
    clearHorizonFlash();
  }, [isFirstRenderRef, location.pathname, clearHorizonFlash]);

  const pushLoginRequired = searchParams.has(authLoginAuthRequiredSearchParam);
  useEffect(() => {
    if (pushLoginRequired) flash(i18n('Please log in first.'), 'warn');
  }, [pushLoginRequired, i18n]);

  return null;
}
